<template>
  <nav class="main-nav">
    <div class="nav-container">
      <router-link to="/" class="nav-item" active-class="active">
        <div class="nav-icon">🏠</div>
        <div class="nav-text">首页</div>
      </router-link>

      <router-link to="/detection" class="nav-item" active-class="active">
        <div class="nav-icon">🔍</div>
        <div class="nav-text">检测</div>
      </router-link>

      <router-link to="/monitoring" class="nav-item" active-class="active">
        <div class="nav-icon">📹</div>
        <div class="nav-text">监控</div>
      </router-link>

      <router-link to="/settings" class="nav-item" active-class="active">
        <div class="nav-icon">⚙️</div>
        <div class="nav-text">设置</div>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MainNav'
}
</script>

<style scoped>
.main-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: var(--bg-elevated);
  border-top: 1px solid var(--border-light);
  padding: 10px 0;
}

.nav-container {
  display: flex;
  max-width: 500px;
  margin: 0 auto;
  padding: 0 10px;
}

.nav-item {
  flex: 1;
  text-align: center;
  text-decoration: none;
  color: var(--text-tertiary);
  padding: 5px 0;
  transition: all var(--transition-normal);
}

.nav-item.active {
  color: var(--proctor-primary);
}

.nav-icon {
  font-size: 1.2rem;
  margin-bottom: 2px;
}

.nav-text {
  font-size: 0.7rem;
}

.nav-item.active .nav-text {
  font-weight: 600;
}
</style>